import { useState } from "react";

export interface FilterGroup {
  key: string;
  label: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

interface FilterBarProps {
  groups: FilterGroup[];
  onReset: () => void;
  activeCount: number;
}

function FilterRows({ groups }: { groups: FilterGroup[] }) {
  return (
    <div className="space-y-4">
      {groups.map((group) => (
        <div key={group.key} className="flex flex-col gap-2 md:flex-row md:items-start">
          <span className="shrink-0 pt-0.5 text-sm text-foreground-500 md:w-16">{group.label}</span>
          <div className="flex flex-wrap gap-2">
            {group.options.map((option) => {
              const selected = group.value === option;
              return (
                <button
                  key={option}
                  type="button"
                  onClick={() => group.onChange(option)}
                  className={`whitespace-nowrap rounded-md px-3 py-1.5 text-sm transition-colors ${
                    selected
                      ? "bg-primary-500 font-600 text-background-50"
                      : "bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-950"
                  }`}
                >
                  {option}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

export default function FilterBar({ groups, onReset, activeCount }: FilterBarProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-lg border border-background-200/70 bg-background-50 p-4 md:bg-background-100/50">
      <div className="mb-3 flex items-center justify-between lg:mb-4">
        <div className="flex items-center gap-2 text-sm text-foreground-700">
          <i className="ri-filter-3-line text-accent-500" />
          <span>筛选条件</span>
          {activeCount > 0 && (
            <span className="rounded-full bg-accent-500/15 px-2 py-0.5 text-xs text-accent-500">
              已选 {activeCount}
            </span>
          )}
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onReset}
            className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3 py-1.5 text-sm text-foreground-600 transition-colors hover:border-accent-500 hover:text-accent-500"
          >
            <i className="ri-refresh-line" />
            重置
          </button>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3 py-1.5 text-sm text-foreground-600 lg:hidden"
          >
            <i className={open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} />
            {open ? "收起" : "展开"}
          </button>
        </div>
      </div>

      <div className={`${open ? "block" : "hidden"} lg:block`}>
        <FilterRows groups={groups} />
      </div>
    </div>
  );
}